import { Component, OnInit } from '@angular/core';
import * as d3 from 'd3';
import { OrgChart } from 'd3-org-chart';
import employees from "../../../../../assets/json/exampleData.json";
import { RolesAndPermissionsService } from '../../../../services/roles-and-permissions.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { Position } from 'src/app/models/position-role.model';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { concatMap, mergeMap, toArray } from 'rxjs/operators';
import { from } from 'rxjs';
import { HumanResourcesService } from 'src/app/services/human-resources.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss']
})
export class OrganizationComponent implements OnInit {
  data: null;
  dataChart = [];
  actualCompany: any;
  departments = [];
  areas = [];
  positions = [];
  filterPositions = [];
  seeingPosition = null;

  constructor(
    private roleService: RolesAndPermissionsService,
    private authService: AuthenticationService,
    private humanService: HumanResourcesService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.actualCompany = JSON.parse(this.authService.getCurrentCompany());
    this.roleService.getAreas().pipe(
      concatMap((response: ResponseObject) => {
        this.areas = response.data;
        console.log(this.areas);
        return this.roleService.getDepartments();
      }),
      concatMap((response: ResponseObject) => {
        this.departments = response.data;
        this.departments.forEach((department) => {
          var area = this.areas.find((a) => {
            return a.id == department.area
          });
          department['areaName'] = area.name;
        })
        return this.roleService.getPositions();
      }),
      concatMap((response: ResponseObject) => {
        this.positions = response.data as Position[];
        this.positions.forEach(position => {
          var deparment = this.departments.find((d) => {
            return d.id == position.department
          });
          position['departmentArea'] = deparment.name;
        });
        const contractObservables = this.positions.map((position: any) => {
          return this.humanService.getContractsPosition(position.id).pipe(
            mergeMap((responseContract: ResponseObject) => {
              // Asignar los empleados al atributo 'data' de la posición
              position['data'] = responseContract.data;
              return from([position]);
            })
          );
        });
        return from(contractObservables).pipe(mergeMap(employees => employees), toArray());
      }),
      // Puedes seguir encadenando tantas peticiones como sea necesario
    )
      .subscribe((dataWithEmployees: any[]) => {
        console.log(dataWithEmployees);
        this.positions = dataWithEmployees;
        var total_company = 0;
        var total_data = [];
        this.positions.forEach((p)=>{
          total_company+= p.data.length;
          total_data.push(...p.data);
        })
        this.dataChart.push({
          id: "0",
          image: this.actualCompany.companyLogo,
          name: this.actualCompany.companyName,
          parentId: "",
          position: "Empresa",
          totalHired: total_company,
          data: total_data,
          _directSubordinates: 0,
          _directSubordinatesPaging: 0,
          _pagingButton: false,
          _totalSubordinates: 0
        })
        this.positions.forEach(position => {
          var element = {
            id: position.id + "",
            image: "../../../../../assets/img/nophoto.svg",
            name: position.name,
            parentId: (position.superior ? position.superior : '0') + "",
            position: 'Departamento ' + position['departmentArea'],
            totalHired: position.data.length,
            data: position.data,
            _directSubordinates: 0,
            _directSubordinatesPaging: 0,
            _pagingButton: false,
            _totalSubordinates: 0
          };
          this.dataChart.push(element);
        });
        new OrgChart()
          .nodeHeight((d) => 150)
          .nodeWidth((d) => 220 + 2)
          .compact(false)
          .childrenMargin((d) => 50)
          .compactMarginBetween((d) => 35)
          .compactMarginPair((d) => 30)
          .neighbourMargin((a, b) => 20)
          .nodeContent(function (d, i, arr, state) {
            const color = '#FFFFFF';
            const imageDiffVert = 25 + 2;
            var maxSizeText = 45;
            d.data.image = d.data.image.includes('company-avatar')?'../../../../../assets/img/nophoto.svg':d.data.image;
            var tempName = d.data.name.length > maxSizeText ? `<span class='name-company'>${d.data.name}</span>${d.data.name.slice(0, maxSizeText)}`+"...": d.data.name;
            return `
                    <div class='org-chart-data' style='width:${d.width}px;padding-top:${imageDiffVert - 2}px;padding-left:1px;padding-right:1px'>
                      <div class='data-company' style="font-family:'Nunito', sans-serif;background-color:${color};  margin-left:-1px;width:${d.width - 2}px;border-radius:10px;border: 1px solid #E4E2E9">
                        <div style="display:flex;justify-content:flex-end;align-items: center;margin-top:5px;margin-right:8px; font-size: 1.5em;"><i class='fa fa-people-group'></i><b> ${d.data.totalHired}</b></div>
                        <div style="background-color:${color};margin-top:${-imageDiffVert - 20}px;margin-left:${15}px;border-radius:100px;width:50px;height:50px;" ></div>
                        <div style="margin-top:${-imageDiffVert - 20}px;">   
                          <img src=" ${d.data.image}" style="margin-left:${20}px;border-radius:100px;width:40px;height:40px;" /></div>
                        <div class='container-name' style="font-weight: 700;font-size:15px;color:#08011E;margin-left:20px;margin-top:10px">${tempName}</div>
                        <div style="color:#716E7B;margin-left:20px;margin-top:3px;font-size:10px;"> ${d.data.position} </div>
                      </div>
                    </div>
                    `;
          })
          .container('.chart-container')
          .data(this.dataChart)
          .onNodeClick(d => {
            this.seeingPosition = d.data;
            if (this.seeingPosition.data.length > 0){
              this.filterPositions = this.seeingPosition.data;
            } else {
              this.toastService.info("No se tienen contratado personal para "+this.seeingPosition.name);
            }
          })
          .render();
      });
  }
}

